import { render, staticRenderFns } from "./BaseCardTabbed.vue?vue&type=template&id=1cd71f32&"
import script from "./BaseCardTabbed.vue?vue&type=script&lang=js&"
export * from "./BaseCardTabbed.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardTabbed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd71f32')) {
      api.createRecord('1cd71f32', component.options)
    } else {
      api.reload('1cd71f32', component.options)
    }
    module.hot.accept("./BaseCardTabbed.vue?vue&type=template&id=1cd71f32&", function () {
      api.rerender('1cd71f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/BaseCardTabbed.vue"
export default component.exports